const _ = require('lodash');

function isPostalCode (value) {
  return /^[1-9][0-9]{3}\W?[a-zA-Z]{2}$/.test(_.trim(value));
}

module.exports = isPostalCode;
